export default function kelvinToFahr(kelvin) {
  return (kelvin - 273.15) * (9 / 5) + 32;
}
